import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { DependencyService } from 'src/app/___LOGIC/__common/dependency.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-shopify-orders',
  templateUrl: './shopify-orders.component.html',
  styleUrls: ['./shopify-orders.component.css']
})
export class ShopifyOrdersComponent implements OnInit {

  selectedOrder: any = null;
  shopifyOrders = [];
  
  constructor(private resolver: ResolverService,private router: Router,private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,public dialog: MatDialog,private apiConnector: ApiConnectorService,private dependencyService: DependencyService) {}

  ngOnInit(): void {
    this.fetch();
  }

  fetch(){
    this.dependencyService.getTableData('shopifyOrder').subscribe(
      (res) => {
        console.log('GET shopifyOrders');
        this.shopifyOrders = res.items;
      },
      (err) => {}
    );
  }

  reload(){
    this.fetch();
  }

  isLoading(){
    return this.resolver.isLoading('getShopifyOrders');
  }

  getOrders(){
    return this.resolver.resolveList('getAllOrders');
  }

  copyCode(order){
    this.commonFunctions.copyToClipboard(order.orderCode);
  }


  viewOrderDetails(order: any): void {
    this.selectedOrder = order;
  }

  closeDetails(): void {
    this.selectedOrder = null;
  }

  getOrderInfo(){
    debugger
    const data = JSON.parse(this.selectedOrder.orderInfo);
    // Access the 'products' array
    const products = data.products;

    if(products){
      return products;
    }else{
      return [];
    }
  }

  getOrderProducts(){
    let products = [];
    JSON.parse(this.selectedOrder.orderInfo)['products']? products = JSON.parse(this.selectedOrder.orderInfo)['products'] : null;
    return products;
  }

  getCustomerInfo(){

    let customerInfo = [];
    JSON.parse(this.selectedOrder.orderInfo)['clientInfo']? customerInfo = JSON.parse(this.selectedOrder.orderInfo)['clientInfo'] : null;
    return customerInfo;

    /* const data = JSON.parse(this.selectedOrder.orderInfo);
    const clientData = data.clientInfo;
    let result = {};
    for(var i in clientData){
      result[i] = clientData[i];
    }
    return result; */
  }

  getAddress(){
    if(this.getCustomerInfo()['default_address'] && this.getCustomerInfo()['address1']){
      return this.getCustomerInfo()['default_address']['address1'];
    }else{
      return "";
    }
  }

  getCustomerName(){
    if(this.getCustomerInfo()['first_name'] && this.getCustomerInfo()['last_name']){
      return this.getCustomerInfo()['first_name']+ ' ' + this.getCustomerInfo()['last_name'];
    }else{
      return "";
    }
  }

  getCustomerEmail(){
    if(this.getCustomerInfo()['email'] ){
      return this.getCustomerInfo()['email'];
    }else{
      return "";
    }
  }

  deleteOrder(id){
    this.apiConnector.deleteOrder(id);
  }

  goBack(){
    
  }

  goToCrudView(table){
/*     sidenav.toggle(); */
    this.router.navigateByUrl('crud/'+table);
  }
}